import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SearchBigData, { DefaultState } from "../components/SearchBigData";
import {
  GetRunningDocu,
  LoadCustomer,
  LoadDocuList,
} from "../../core/BillingComponents";
import { FormType } from "../../model/backoffice/document-type";
import FormAutoObject from "../../core/FormAutoObject";
import { FormObjectService } from "../../core/FieldObject";
import { GetBillingNoteHeaderObject } from "../../core/BillingNoteComponent";
import { SearchAllCustomer, SearchCustomer } from "../../model/customer";
import { GetCreateTable, GetListForm } from "../../core/Helper2";
import {
  AlertError,
  CreateTooltip,
  FormatCurrency,
  GetHeaderStyle,
  GetNormalStyle,
  GetShortDateNum,
  GetThaiFormatDate,
  IsEmptyArray,
  XButton,
} from "../../core/Helper";
import { WebSearchHelperService } from "../tools/search-helper";
import { encode } from "js-base64";
import {
  DocumentService,
  SearchBillNote,
} from "../../model/backoffice/document";
import BillViewer, {
  FormDocuType,
} from "../../components/bill-forms/BillViewer";
import { AiOutlineCalendar } from "react-icons/ai";
import OfficeFormToolbar, {
  OfficeFormToobarHeader,
} from "../tools/OfficeFormToolbar";
import { textFilter } from "react-bootstrap-table2-filter";
import styled from "styled-components";
import { CgClose } from "react-icons/cg";
import ConfirmDialogB from "../components/ConfirmDialogB";
import { BiSearch } from "react-icons/bi";
import { Oval } from "react-loading-icons";
import { BsCollection } from "react-icons/bs";

import MonthSelector from "../../core/MonthSelector";
import { FormSelectBlack } from "../components/PageParams";
import { BranchService } from "../../model/branch";

export default function BranchBillingNote(props) {
  const user = useSelector((state) => state.user);
  const [editor, setEditor] = props.list;

  const [data, setData] = useState({});

  // const [tbPL, setTbPL] = useState(null);
  // const [curPL, setCurPL] = useState(null);
  // const [plData, setPlData] = useState([]);

  const [tbInv, setTbInv] = useState(null);
  const [invData, setInvData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [searchBig, setSearchBig] = useState();
  const [selectedItems, setSelectedItems] = useState([]);
  // const [dateRangeValues, changeDateRange] = useState([new Date(), new Date()]);
  const [runningDocu, setRunningDocu] = useState();

  const [curDocu, setCurDocu] = useState(null);
  const [docuList, setDocuList] = useState([]);
  const [objHead1, setobjHead1] = useState(null);
  const [objHead2, setobjHead2] = useState(null);
  const [billSelector, setBillSelector] = useState(DefaultState);
  const [billViewer, setBillViewer] = useState();

  const [branchList, setBranchList] = useState([]);
  const [monthInfo, setMonthInfo] = useState({});
  const [curBranch, setCurBranch] = useState(null);
  const ref1 = useRef();
  const ref2 = useRef();
  const documentIdFieldName = "BillNoteId";

  const dispatch = useDispatch();

  useEffect(() => {
    if (editor?.show) {
      LoadDocuList([user.detail, setDocuList], FormType.BILLING_NOTE);
      loadBranch();
      // changeDateRange([new Date(), new Date()]);
      setData({});
      setSearchBig(DefaultState);
      setCurDocu({ [documentIdFieldName]: 0 });
      setSelectedItems([]);

      return () => {
        console.log("return...");
        setTbInv(null);
        setInvData([]);
        setSelectedItems(null);
        setobjHead1(null);
        setobjHead2(null);
        setData(null);
        setSearchBig(null);
        setCurDocu(null);
        setBillViewer(null);
      };
    }
  }, [editor?.show]);

  const loadBranch = async () => {
    let res = await BranchService.GetNewList(user.detail);
    if (res?.length > 0) {
      setBranchList(res ?? []);
      //updateCompany(res[0]?.compid);
    }
  };

  // useEffect(() => {
  //   if (editor?.show) {
  //     console.log("data", data);
  //   }
  // }, [data]);
  /** โหลดประเภทเอกสาร */
  useEffect(() => {
    if (editor?.show) {
      /** สร้างหัวเอกสาร */
      buildHeader([setobjHead1], 1, ref1);
      buildHeader([setobjHead2], 2, ref2);
    }
  }, [docuList, data?.DocuNo, data?.Customer]);

  /** รันเลขเอกสาร */
  useEffect(() => {
    if (editor?.show) {
      if (data?.DocuBranch) {
        let invId = data?.[documentIdFieldName];
        if (!invId) {
          // get latest running no if no invoice-id isfound
          if (data?.[documentIdFieldName] <= 0) {
            GetRunningDocu([
              data,
              setData,
              user.detail,
              setRunningDocu,
              documentIdFieldName,
            ]);
          }
        }
      }
    }
  }, [data?.DocuBranch]);

  /** สร้างหัวเอกสาร */
  const buildHeader = async ([setter], sectionId, ref) => {
    ref.current?.reset();
    setter(
      <FormAutoObject
        {...{
          items: await FormObjectService.BuildsFormOBJs(
            GetBillingNoteHeaderObject({
              docuList: docuList,
              docuFieldIdName: documentIdFieldName,
              head: data,
              sectionId: sectionId,
              custClick,
            })
          ),
          dataValue: [data, setData],
          refTo: ref,
        }}
      />
    );
  };

  // useEffect(() => {
  //   console.log(monthInfo);
  // }, [monthInfo]);

  const custClick = (item) => {
    SearchAllCustomer(
      [setSearchBig, data, setData, user.detail, item],
      async (result) => {
        await LoadCustomer(result?.custid, [user.detail, setData]);
        setSearchBig((pv) => ({ ...pv, show: false }));
      }
    );
  };
  /** เมื่อมีการดึงข้อมูล Invoice */
  useEffect(() => {
    setTbInv(
      GetCreateTable({
        idFieldName: "item_id",
        columns: [...invListCol, deleteCol({ deleteRow: () => alert("ok") })],
        data: invData,
        pageOptionProps: { hideSizePerPage: true },
      })
    );
    // console.log("InvDATa", invData);
  }, [invData]);

  const loadStudyItems = async () => {
    if (!data?.Customer) return;

    let sql =
      "call rp_billnote_monthly_maker(" +
      data?.Customer?.CustId +
      ", '" +
      GetShortDateNum(monthInfo?.dates[0]) +
      "', '" +
      GetShortDateNum(monthInfo?.dates[1]) +
      "'," +
      "'radi_pay_flag=\\'n\\' ');";

    setLoading(true);
    let res = await WebSearchHelperService.GetBasicReport(
      {
        text: null,
        root: null,
        sql: encode(sql),
      },
      user.detail
    );
    setLoading(false);

    if (res) {
      setInvData(res);
    }
  };

  /** Load ใบแจ้งหนี้ */
  const loadInvoicelist = async (billNoteId) => {
    // if (curPL === null) return;
    if (curDocu === null) return;
    let sql = "call rp_billnote_monthly_saved_detail(" + billNoteId + ",'')";
    setLoading(true);

    let res = await WebSearchHelperService.GetBasicReport(
      {
        text: null,
        root: null,
        sql: encode(sql),
      },
      user.detail
    );
    setLoading(false);

    if (res) {
      setInvData(res);
    }
  };

  /**เมื่อบันทึกใบวางบิล */
  const saveData = async () => {
    if (!invData.length) {
      AlertError("กรุณาตรวจสอบยอดวางบิล", dispatch);
      return;
    }

    if (!data?.Customer?.CustId) {
      AlertError("กรุณาเลือกลูกค้าหรือ รพ. เพื่อวางบิล", dispatch);
      return;
    }

    let listInvoiceId = [];
    invData?.map((item, i) => {
      listInvoiceId.push(item?.item_id);
    });

    setLoading(true);
    let ret = await DocumentService.SaveBillingNote(
      {
        ...data,
        DocuBranch: runningDocu,
        InvoiceList: listInvoiceId,
        DateRange: monthInfo,
      },
      user.detail
    );
    setData(ret);
    setLoading(false);
    // console.log(ret
    // );
  };

  useEffect(() => {
    // console.log(invData);
    if (editor?.show) {
      if (IsEmptyArray(invData)) return;
      let sum = 0;
      invData?.map((item, i) => {
        sum += item?.["price"];
      });
      setData((pv) => ({ ...pv, NetTotal: sum }));
    }
  }, [invData]);

  const addNewBill = () => {
    setData({});
    // setPlData([]);
    setInvData([]);
    setCurDocu(null);
  };

  // const openSelector = () => {
  //   setBillSelector((pv) => ({ ...pv, show: true }));
  // };

  /** ค้นบิลและทำการเลือกเอกสารเก่า */
  const searchClick = (item) => {
    SearchBillNote([
      setSearchBig,
      curDocu,
      setCurDocu,
      user.detail,
      {
        fieldName: documentIdFieldName,
      },
    ]);
  };

  /** ค้นบิลและทำการเลือกเอกสารเก่า */
  const deleteClick = (item) => {};

  /** เมื่อมีการเลือกเอกสารเก่า */
  useEffect(() => {
    if (
      editor?.show &&
      curDocu !== null &&
      data?.[documentIdFieldName] !== undefined
    ) {
      if (curDocu !== data?.[documentIdFieldName]) {
        loadUnBillingNote();
      }
    }
  }, [curDocu]);

  const loadUnBillingNote = async () => {
    let res = await DocumentService.GetBillingNote(curDocu, user.detail);
    setData(res);
    loadInvoicelist(curDocu?.[documentIdFieldName]);
  };

  const printData = () => {
    setBillViewer((pv) => ({
      ...pv,
      show: true,
      formDocuType: FormDocuType.BILLING_NOTE,
    }));
  };

  return (
    <>
      <GetListForm
        {...{
          list: [editor, setEditor],
          size: "lg",
          title: editor?.title ?? "วางบิลเรียกเก็บประจำเดือน",
          fullscreen: true,
          icon: (
            <AiOutlineCalendar
              color="var(--icon-fore)"
              style={{ marginInlineEnd: "10px" }}
              size={30}
            />
          ),
        }}
      >
        <OfficeFormToolbar
          {...{
            addNewBill,
            searchClick,
            saveData,
            // selectedItems,
            searchButtonTitle: "ค้นใบวางบิล",
            saving,
            printData,
            deleteData: deleteClick,
          }}
        />

        <OfficeFormToobarHeader
          {...{
            objHead1,
            objHead2,
            title: "ยอดวางบิล",
            data,
            netFieldName: "NetTotal",
          }}
        />

        {/*  */}
        {/*  */}
        <MainDiv>
          {/* <LeftDiv> */}
          {/* <SelectPanel>     
            </SelectPanel> */}
          {/* </LeftDiv> */}
          <RightDiv>
            <ListBox>
              <BarRightBox>
                <MonthSelector info={[monthInfo, setMonthInfo]} />
                <HBox>
                  <XButton
                    marginInline="10px"
                    onMouseUp={() => loadStudyItems()}
                  >
                    {" "}
                    <BiSearch
                      size={20}
                      title="ค้น"
                      color="var(--icon-fore)"
                      style={{ marginInlineEnd: "10px" }}
                    />{" "}
                    แสดงรายการค้างชำระ
                  </XButton>
                </HBox>
              </BarRightBox>
              <div>
                {loading ? (
                  <Oval height={20} style={{ marginInlineStart: "3px" }} />
                ) : (
                  <BsCollection
                    color="var(--icon-fore)"
                    size={30}
                    style={{ marginInline: "10px" }}
                  />
                )}
                รายชื่อคนไข้
              </div>
              <div></div>
            </ListBox>

            <RightTableContainer>{tbInv}</RightTableContainer>
          </RightDiv>
        </MainDiv>
      </GetListForm>

      <SearchBigData
        {...{ winState: [searchBig, setSearchBig], dateFilter: false }}
      />
      <ConfirmDialogB {...{ winState: [confirm, setConfirm] }} />
      <BillViewer
        {...{
          billViewer: [billViewer, setBillViewer],
          data: [data, setData],
          items: invData,
        }}
      />
    </>
  );
}

export const invListCol = [
  {
    dataField: "request_date",
    text: "วันที่รับบริการ",
    sort: true,
    headerStyle: GetHeaderStyle("80px"),
    style: () => GetNormalStyle("center"),
    filter: textFilter({ placeholder: "..." }),
    formatter: (cell, row) => GetThaiFormatDate(cell),
  },

  {
    dataField: "hn",
    text: "HN",
    sort: true,
    headerStyle: GetHeaderStyle("100px"),
    style: () => GetNormalStyle("left"),
    filter: textFilter({ placeholder: "..." }),
  },
  {
    dataField: "patients_name",
    text: "ชื่อสกุลคนไข้",
    sort: true,
    headerStyle: GetHeaderStyle("100px"),
    style: () => GetNormalStyle("left"),
    filter: textFilter({ placeholder: "..." }),
  },
  {
    dataField: "item_name",
    text: "รายการตรวจ",
    sort: true,
    headerStyle: GetHeaderStyle("100px"),
    style: () => GetNormalStyle("left"),
    filter: textFilter({ placeholder: "..." }),
  },
  {
    dataField: "price",
    text: "ยอดรวม",
    sort: true,
    headerStyle: GetHeaderStyle("80px"),
    style: () => GetNormalStyle("right"),
    filter: textFilter({ placeholder: "..." }),
    formatter: FormatCurrency,
  },
];

const deleteCol = (props) => {
  const { deleteRow } = props;
  return {
    dataField: "",
    isDummyField: true,
    headerStyle: GetHeaderStyle("30px"),
    style: () => GetNormalStyle("center", "var(--icon-fore)"),
    formatter: (cell, row, rowIndex) => (
      <XButton
        onMouseUp={() => deleteRow(row)}
        paddingInline="2px"
        hoverBackColor="red"
      >
        {CreateTooltip(
          "ลบแถว",
          <div>
            <CgClose size={20} />
          </div>
        )}
      </XButton>
    ),
  };
};

const BarRightBox = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  padding-inline-start: 10px;
`;

export const RightTableContainer = styled.div`
  /* min-width: 1500px; */
`;

export const LeftDiv = styled.div`
  display: flex;
  min-width: 350px;
  padding-block-end: 10px;
  padding-inline: 10px;
  flex: 1;
  align-items: start;
`;
export const RightDiv = styled.div`
  display: flex;
  flex-direction: column;
  padding-inline-start: 5px;
`;

export const MainDiv = styled.div`
  padding-block-start: 10px;
  flex: 1;
  display: flex;
  flex-direction: row;
  /* flex-wrap: wrap; */
`;

export const ListBox = styled.div`
  padding-block: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: var(--fore-primary);
  background-color: var(--x-bg-thirth);
  border-radius: 5px;
`;

export const SelectPanel = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  border: 1px solid var(--border-color);
  border-radius: 5px;
  padding: 10px;
  flex-direction: column;
  flex: 1;
`;

export const HBox = styled.div`
  /* margin-inline: 10px; */
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: var(--caption-fore-color);
`;

export const MenuContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;
